import { useCallback } from 'react';

import { trackClickEvent } from '../../services/tracking/pulseEvents';

export const useFavouritesTracking = () => {
  const trackFavouritesClick = useCallback(
    (id, title, checked, parentComponent) => {
      const parent = {
        elementType: parentComponent,
      };

      const object = {
        title: title,
        elementType: 'FavouritesButton',
        id: `${id}:${checked ? 'remove' : 'add'}`,
      };

      const target = {
        type: 'FavouritesPage',
        title: 'Favourites',
      };

      trackClickEvent(parent, object, target);
    },
    []
  );

  return {
    trackFavouritesClick,
  };
};
